module.exports = __webpack_public_path__ + "res/favicon.00cb259f06de81a21c7b14f09de5c929.png";